import adminApi from "../axios";

function authConfig(extra = {}) {
  return {
    ...extra,
    headers: {
      ...extra.headers,
      Authorization: `Bearer ${localStorage.getItem("@token")}`,
    },
  };
}

function dataOf(response) {
  return response?.data?.data ?? response?.data ?? [];
}

export async function listCoursePayments(params = {}) {
  const response = await adminApi.get("course-payments", authConfig({ params }));
  return {
    payments: Array.isArray(response?.data?.data) ? response.data.data : [],
    pagination: response?.data?.pagination || null,
  };
}

export async function getCoursePayment(paymentId) {
  return dataOf(await adminApi.get(`course-payments/${paymentId}`, authConfig()));
}

export async function decideCoursePayment(paymentId, payload) {
  return dataOf(
    await adminApi.post(`course-payments/${paymentId}/decision`, payload, authConfig())
  );
}

export async function listUsers() {
  const response = await adminApi.get("users", authConfig());
  const data = dataOf(response);
  return Array.isArray(data) ? data : [];
}
